import { Box, Container, Typography } from "@material-ui/core"
import GenericButton from "components/GenericButton/GenericButton"
import dynamic from "next/dynamic"
import { useRouter } from "next/router"
import { useEffect } from "react"
import styled from "styled-components"
import glass from "../../public/animation/Purchase successful.json"

const Lottie = dynamic(() => import("lottie-react"), { ssr: false })

const StyledWrapper = styled(Container)`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  ${(p) => p.theme.breakpoints.down("sm")} {
    height: 80vh;
    justify-content: flex-start;
    padding-top: 50px;
  }
`

const StyledTitle = styled(Typography).attrs({ variant: "h1" })`
  font-size: 40px;
  line-height: 0.8;
  color: #000;
  margin-top: -35px;
  ${(p) => p.theme.breakpoints.up("md")} {
    margin-top: -80px;
    font-size: 50px;
  }
`

const StyledText = styled(Typography).attrs({ variant: "body1" })`
  margin-top: 10px;
  line-height: 0.92;
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-top: 22px;
  }
`

const StyledButtonWrapper = styled(Box)`
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
    position: absolute;
    padding-left: 16px;
    padding-right: 16px;
    bottom: 30px;
  }

  ${(p) => p.theme.breakpoints.up("md")} {
    margin-top: 40px;
  }
`

const StyledLottie = styled(Lottie)`
  width: 600px;
  height: 450px;
  margin-top: -100px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 368px;
    height: 310px;
    margin-top: 0px;
  }
`

const SuccessPage = () => {
  const router = useRouter()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <StyledWrapper>
      <StyledLottie animationData={glass} loop={false} />
      <StyledTitle>תודה! קיבלנו את הפרטים</StyledTitle>
      <StyledText>
        אחד מהנציגים/ות שלנו יחזור אליך בהקדם עם הצעה משתלמת :)
      </StyledText>
      <StyledButtonWrapper>
        {" "}
        <GenericButton btnType="filled" onClick={() => router.push("/")}>
          לעמוד הבית
        </GenericButton>
      </StyledButtonWrapper>
    </StyledWrapper>
  )
}

export default SuccessPage
